module.exports = __webpack_public_path__ + "img/Speaker=Sarah Gray.862411a5.png";